const namespace = 'API'

export const ADD_NEWSLETTER_PENDING = `${namespace}/ADD_NEWSLETTER_PENDING`
export const ADD_NEWSLETTER_SUCCESS = `${namespace}/ADD_NEWSLETTER_SUCCESS`
export const ADD_NEWSLETTER_FAIL = `${namespace}/ADD_NEWSLETTER_FAIL`
export const ADD_RECRUIT_PENDING = `${namespace}/ADD_RECRUIT_PENDING`
export const ADD_RECRUIT_SUCCESS = `${namespace}/ADD_RECRUIT_SUCCESS`
export const ADD_RECRUIT_FAIL = `${namespace}/ADD_RECRUIT_FAIL`
export const ADD_PROJECT_PENDING = `${namespace}/ADD_PROJECT_PENDING`
export const ADD_PROJECT_SUCCESS = `${namespace}/ADD_PROJECT_SUCCESS`
export const ADD_PROJECT_FAIL = `${namespace}/ADD_PROJECT_FAIL`
export const ADD_PDS_PENDING = `${namespace}/ADD_PDS_PENDING`
export const ADD_PDS_SUCCESS = `${namespace}/ADD_PDS_SUCCESS`
export const ADD_PDS_FAIL = `${namespace}/ADD_PDS_FAIL`
